import { telemetry } from "../constants";
export function formatLoadBetsTrackingData({ action, status, previousStatus, bets, events, }) {
    const betsArr = [...bets.values()];
    const eventsArr = [...events.values()];
    const openBetsArr = betsArr.filter(bet => bet.settlementStatus === "Open");
    return {
        Action: action,
        ClientType: telemetry.clientType,
        CurrentTab: previousStatus,
        NewTab: status,
        LoadedBetsCount: `${bets.size}`,
        NumberOfOpenBets: openBetsArr.length,
        NumberOfEvents: eventsArr.length,
        NumberOfEventsPastEventStartDate: openBetsArr.length > 0
            ? eventsArr.filter(event => (new Date(event.eventStartDate).getTime() - new Date().getTime()) < 0).length
            : 0,
        MyBetsVersion: telemetry.version,
    };
}
//# sourceMappingURL=formatLoadBetsTrackingData.js.map